(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('SpecificQuestionDeleteController',SpecificQuestionDeleteController);

    SpecificQuestionDeleteController.$inject = ['$uibModalInstance', 'entity', 'SpecificQuestion'];

    function SpecificQuestionDeleteController($uibModalInstance, entity, SpecificQuestion) {
        var vm = this;

        vm.specificQuestion = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SpecificQuestion.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
